import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_END_POINTS } from '../constant/api.constant';

@Injectable({
    providedIn: 'root'
})
export class NewsService {

    constructor(private http: HttpClient) {
    }

    getNews(query: any) {
        return this.http.get(`${API_END_POINTS.NEWS.news}?${query}`);
    }

    getNewsById(id): Observable<any>{
        return this.http.get(`${API_END_POINTS.NEWS.news}/${id}`)
    }
}
